module.exports = __webpack_public_path__ + "img/menu.8b4e92ec.png";